module.exports = __webpack_public_path__ + "img/logo-monitoring.a97b6bdd.png";